import React, { Component, Fragment } from 'react';

// import DesktopRegister from './DesktopRegister/DesktopRegister';
import MobileRegister from './MobileRegister/MobileRegister';

export default class Register extends Component {
  render() {
    let register;
    if (window.innerWidth > 900) {
      register = null;
    }
    else if (window.innerWidth < 900) {
      register = <MobileRegister />;
    }
    return (
      <Fragment>
        { register}
      </Fragment>
    );
  }
}

